// import Breadcrumb from '../../../components/Breadcrumbs/Breadcrumb';
import DefaultLayout from '../../../layout/DefaultLayout';
import SectionWrapper from '../../../components/SectionWrapper/SectionWrapper';
import PurchaseCancelPanel from '../../../components/purchases/cancel/PurchaseCancelPanel';
import BreadcrumbTwo from '../../../components/Breadcrumbs/BreadcrumbTwo';
// import PurchaseCancelPanel from '../../../components/Purchases/cancel/PurchaseCancelPanel';

const PurchaseCancel = () => {
  return (
    <DefaultLayout>
      {/* <Breadcrumb
        pageName="Anular Compra"
        routes={[
          { name: 'Historial de Compras', to: '/purchase-history' },
        ]}
      /> */}
      <BreadcrumbTwo />

      <SectionWrapper>
        <PurchaseCancelPanel />
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default PurchaseCancel;
